import { render, staticRenderFns } from "./wine-investor2.vue?vue&type=template&id=374490f0&scoped=true"
import script from "./wine-investor2.vue?vue&type=script&lang=js"
export * from "./wine-investor2.vue?vue&type=script&lang=js"
import style0 from "./wine-investor2.vue?vue&type=style&index=0&id=374490f0&prod&scoped=true&lang=css"
import style1 from "./wine-investor2.vue?vue&type=style&index=1&id=374490f0&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374490f0",
  null
  
)

export default component.exports